document.addEventListener('DOMContentLoaded', () => {
  const selectors$a = {
    scrollbar: '[data-custom-scrollbar]',
    scrollbarItems: '[data-custom-scrollbar-items]',
    scrollbarThumb: '[data-custom-scrollbar-thumb]',
  };
  
  const selectors$8 = {
    option: '[data-option]',
    popout: '[data-popout]',
    productMediaSlider: '[data-product-single-media-slider]',
    productMediaThumb: '[data-thumbnail-id]',
    productMediaThumbs: '[data-product-single-media-thumbs]',
    productMediaWrapper: '[data-product-single-media-wrapper]',
    productModel: '[data-model]',
    productSingleThumbnailLink: '.product-single__thumbnail-link',
    deferredMedia: '[data-deferred-media]',
    deferredMediaButton: '[data-deferred-media-button]',
    productTabs: '[data-tabs-holder]',
    formWrapper: '[data-form-wrapper]',
    tooltip: '[data-tooltip]',
    productRating: '[data-product-rating]',
    productReviews: '#shopify-product-reviews',
    links: 'a, button',
    upsellProduct: '[data-upsell-holder]',
    upsellProductSlider: '[data-upsell-slider]',
  };

  const selectors$9 = {
    tabLink: '[data-tab-link]',
    tabContent: '[data-tab-content]',
    scrollable: '[data-custom-scrollbar]',
    scrollableHolder: '[data-custom-scrollbar-holder]',
    slider: '[data-slider]',
    tabsContents: '[data-tabs-contents]',
  };

  const classes$6 = {
    featuredProduct: 'featured-product',
    featuredProductOnboarding: 'featured-product--onboarding',
    hasMediaActive: 'has-media-active',
    isSelected: 'is-selected',
    mediaHidden: 'media--hidden',
    noOutline: 'no-outline',
    hasPopup: 'has-popup',
    isMoving: 'is-moving',
  };

  const classes$7 = {
    current: 'current',
    hide: 'hide',
    alt: 'alt',
    aosAnimate: 'aos-animate',
    aosInit: 'aos-init',
  };

  const attributes$6 = {
    mediaId: 'data-media-id',
    sectionId: 'data-section-id',
    thumbId: 'data-thumbnail-id',
    dataTallLayout: 'data-tall-layout',
    loaded: 'loaded',
    tabindex: 'tabindex',
  };

  const attributes$7 = {
    tabLink: 'data-tab-link',
    tabContent: 'data-tab-content',
    tabStartIndex: 'data-start-index',
  };

  // iOS smooth scrolling fix
  function flickitySmoothScrolling(slider) {
    const flkty = Flickity.data(slider);

    if (!flkty) {
      return;
    }

    flkty.on('dragStart', (event, pointer) => {
      document.ontouchmove = function (e) {
        e.preventDefault();
      };
    });

    flkty.on('dragEnd', (event, pointer) => {
      document.ontouchmove = function (e) {
        return true;
      };
    });
  }

  async function initProductSlider(contentContainer) {
    const slider = contentContainer.querySelector('[data-product-single-media-slider]');
    const thumbs = contentContainer.querySelector('[data-product-single-media-thumbs]');
    const media = contentContainer.querySelectorAll('[data-product-single-media-wrapper]');
    let flkty;

    if (media.length > 1) {
      flkty = new Flickity(slider, {
        wrapAround: true,
        pageDots: false,
        adaptiveHeight: true,
        on: {
          ready: () => {
            slider.setAttribute(attributes$6.tabindex, '-1');

            media.forEach((item) => {
              if (!item.classList.contains(classes$6.isSelected)) {
                const links = item.querySelectorAll(selectors$8.links);
                if (links.length) {
                  links.forEach((link) => {
                    link.setAttribute(attributes$6.tabindex, '-1');
                  });
                }
              }
            });
          },
          dragStart: () => {
            slider.classList.add(classes$6.isMoving);
          },
          dragMove: () => {
            // Prevent lightbox trigger on dragMove
            this.isFlickityDragging = true;
          },
          staticClick: () => {
            this.isFlickityDragging = false;
          },
          settle: (index) => {
            const currentSlide = this.flkty.selectedElement;
            const mediaId = currentSlide.getAttribute(attributes$6.mediaId);

            this.flkty.cells.forEach((slide, i) => {
              const links = slide.element.querySelectorAll(selectors$8.links);
              if (links.length) {
                links.forEach((link) => {
                  link.setAttribute(attributes$6.tabindex, i === index ? '0' : '-1');
                });
              }
            });
            this.switchMedia(mediaId);
            slider.classList.remove(classes$6.isMoving);
          },
        },
      });

      // Toggle flickity draggable functionality based on media play/pause state
      if (media.length) {
        media.forEach((el) => {
          el.addEventListener('theme:media:play', () => {
            this.flkty.options.draggable = false;
            this.flkty.updateDraggable();
            el.closest(selectors$8.productMediaSlider).classList.add(classes$6.hasMediaActive);
          });

          el.addEventListener('theme:media:pause', () => {
            this.flkty.options.draggable = true;
            this.flkty.updateDraggable();
            el.closest(selectors$8.productMediaSlider).classList.remove(classes$6.hasMediaActive);
          });
        });
      }

      // iOS smooth scrolling fix
      flickitySmoothScrolling(slider);

      if (thumbs !== null) {
        const thumbsConfig = {
          asNavFor: slider,
          contain: true,
          pageDots: false,
          prevNextButtons: false,
          groupCells: '100%',
          resize: true,
          on: {
            ready: () => {
              thumbs.setAttribute(attributes$6.tabindex, '-1');
            },
          },
        };

        if (thumbs.dataset.vertical === 'true') {
          if (matchMedia('screen and (min-width: 480px)').matches) {
            thumbsConfig.prevNextButtons = true;
            thumbsConfig.draggable = false;
          }
          thumbsConfig.on = {...thumbsConfig.on, resize: () => this.onResizeFlkty()};
        }

        this.flktyNav = new Flickity(thumbs, thumbsConfig);

        if (this.flktyNav !== null) {
          document.addEventListener('theme:resize:width', this.flktyNavOnResize);
        }

        // iOS smooth scrolling fix
        flickitySmoothScrolling(thumbs);

        // Disable link click
        const thumbLinks = contentContainer.querySelectorAll(selectors$8.productSingleThumbnailLink);
        if (thumbLinks.length) {
          thumbLinks.forEach((el) => {
            el.addEventListener('click', (e) => {
              e.preventDefault();
            });
          });
        }
      }
    }
  }

  class CustomScrollbar {
    constructor(container) {
      this.container = container;
      this.scrollbarItems = container.querySelector(selectors$a.scrollbarItems);
      this.scrollbar = container.querySelector(selectors$a.scrollbar);
      this.scrollbarThumb = container.querySelector(selectors$a.scrollbarThumb);
      this.trackWidth = 0;
      this.calcScrollbarEvent = () => this.calculateScrollbar();
      this.onScrollbarChangeEvent = (e) => this.onScrollbarChange(e);

      if (this.scrollbar && this.scrollbarItems) {
        this.events();
        this.calculateScrollbar();
        if (this.scrollbarItems.children.length) {
          this.calculateTrack(this.scrollbarItems.children[0]);
        }
      }
    }

    calculateTrack(element) {
      const thumbScale = element.clientWidth / this.scrollbarThumb.parentElement.clientWidth;
      const thumbPosition = element.offsetLeft / this.scrollbarThumb.parentElement.clientWidth;
      this.scrollbar.style.setProperty('--thumb-scale', thumbScale);
      this.scrollbar.style.setProperty('--thumb-position', `${this.trackWidth * thumbPosition}px`);
    }

    calculateScrollbar() {
      if (this.scrollbarItems.children.length) {
        const childrenArr = [...this.scrollbarItems.children];
        this.trackWidth = this.container.clientWidth;
        // childrenArr.forEach((element) => {
        //   this.trackWidth += element.getBoundingClientRect().width + parseInt(window.getComputedStyle(element).marginRight);
        // });
        // this.scrollbar.style.setProperty('--track-width', `${this.trackWidth}px`);
      }
    }

    onScrollbarChange(e) {
      if (e && e.detail && e.detail.element && this.container.contains(e.detail.element)) {
        this.calculateTrack(e.detail.element);
      }
    }

    events() {
      document.addEventListener('theme:resize:width', this.calcScrollbarEvent);
      document.addEventListener('theme:custom-scrollbar:change', this.onScrollbarChangeEvent);
    }

    unload() {
      document.removeEventListener('theme:resize:width', this.calcScrollbarEvent);
      document.removeEventListener('theme:custom-scrollbar:change', this.onScrollbarChangeEvent);
    }
  }

  class Tabs {
    constructor(container) {
      this.container = container;
      this.tabsContents = container.querySelector(selectors$9.tabsContents);
      this.animateElementsTimer = null;

      if (this.container) {
        this.scrollable = this.container.querySelector(
          `${selectors$9.scrollable}`
        );

        this.init();
        this.initCustomScrollbar();
      }
    }

    init() {
      const tabsNavList = this.container.querySelectorAll(selectors$9.tabLink);
      const firstTabLink = this.container.querySelector(
        `[${attributes$7.tabLink}="${
          this.container.hasAttribute(attributes$7.tabStartIndex)
            ? this.container.getAttribute(attributes$7.tabStartIndex)
            : 0
        }"]`
      );
      const firstTabContent = this.container.querySelector(
        `[${attributes$7.tabContent}="${
          this.container.hasAttribute(attributes$7.tabStartIndex)
            ? this.container.getAttribute(attributes$7.tabStartIndex)
            : 0
        }"]`
      );

      if (firstTabContent) {
        firstTabContent.classList.add(classes$7.current);
      }

      if (firstTabLink) {
        firstTabLink.classList.add(classes$7.current);
      }

      this.checkVisibleTabLinks();

      if (tabsNavList.length) {
        tabsNavList.forEach((element) => {
          const tabId = parseInt(element.getAttribute(attributes$7.tabLink));
          const tab = this.container.querySelector(
            `[${attributes$7.tabContent}="${tabId}"]`
          );

          element.addEventListener("click", () => {
            this.tabChange(element, tab);
          });

          element.addEventListener("keyup", (event) => {
            if (
              event.code === theme.keyboardKeys.SPACE ||
              event.code === theme.keyboardKeys.ENTER ||
              event.code === theme.keyboardKeys.NUMPADENTER
            ) {
              this.tabChange(element, tab);
            }
          });
        });
      }
    }

    initCustomScrollbar() {
      if (!this.scrollable) {
        return;
      }

      this.customScrollbar = new CustomScrollbar(this.container);
    }

    tabChange(element, tab) {
      if (element.classList.contains(classes$7.current)) {
        return;
      }

      const parent = element.closest(selectors$9.scrollableHolder)
        ? element.closest(selectors$9.scrollableHolder)
        : element.parentElement;
      const parentPadding = parseInt(
        window.getComputedStyle(parent).getPropertyValue("padding-left")
      );
      const lastActiveTab = this.container.querySelector(
        `${selectors$9.tabContent}.${classes$7.current}`
      );
      const lastActiveTabLink = this.container.querySelector(
        `${selectors$9.tabLink}.${classes$7.current}`
      );
      const slider = tab.querySelector(selectors$9.slider);

      lastActiveTab.classList.remove(classes$7.current);
      lastActiveTabLink.classList.remove(classes$7.current);
      element.classList.add(classes$7.current);
      tab.classList.add(classes$7.current);

      // Trigger theme:tab:change custom event to reset the selected tab slider position
      if (slider) {
        slider.dispatchEvent(
          new CustomEvent("theme:tab:change", { bubbles: false })
        );
      }

      // Scroll to current tab link
      parent.scrollTo({
        top: 0,
        left:
          element.offsetLeft -
          parent.offsetWidth / 2 +
          element.offsetWidth / 2 +
          parentPadding,
        behavior: "smooth",
      });

      element.dispatchEvent(
        new CustomEvent("theme:custom-scrollbar:change", {
          bubbles: true,
          detail: {
            element: element,
          },
        })
      );

      // Trigger animations if they are enabled
      if (theme.settings.animations) {
        this.tabsContents
          .querySelectorAll(`.${classes$7.aosInit}`)
          .forEach((element) => {
            element.classList.remove(classes$7.aosAnimate);
          });

        if (this.animateElementsTimer) {
          clearTimeout(this.animateElementsTimer);
        }

        this.animateElementsTimer = setTimeout(() => {
          tab.querySelectorAll(`.${classes$7.aosInit}`).forEach((element) => {
            element.classList.add(classes$7.aosAnimate);
          });
        }, 150);
      }

      if (element.classList.contains(classes$7.hide)) {
        tab.classList.add(classes$7.hide);
      }

      this.checkVisibleTabLinks();
    }

    checkVisibleTabLinks() {
      const tabsNavList = this.container.querySelectorAll(selectors$9.tabLink);
      const tabsNavListHidden = this.container.querySelectorAll(
        `${selectors$9.tabLink}.${classes$7.hide}`
      );
      const difference = tabsNavList.length - tabsNavListHidden.length;

      if (difference < 2) {
        this.container.classList.add(classes$7.alt);
      } else {
        this.container.classList.remove(classes$7.alt);
      }
    }

    onBlockSelect(evt) {
      const element = evt.target;
      if (element) {
        element.dispatchEvent(new Event("click"));

        element.parentNode.scrollTo({
          top: 0,
          left: element.offsetLeft - element.clientWidth,
          behavior: "smooth",
        });
      }
    }

    onUnload() {
      if (this.customScrollbar) {
        this.customScrollbar.unload();
      }
    }
  }

  function initTabs(contentContainer) {
    contentContainer.querySelectorAll(selectors$8.productTabs).forEach(tabsHolder => new Tabs(tabsHolder));
  }

  function reloadVendorScript() {
    return new Promise((resolve, reject) => {
      const src = 'https://unpkg.com/flickity@2/dist/flickity.pkgd.min.js';

      // 🧹 Elimina versiones previas del script
      document.querySelectorAll(`script[src*="flickity.pkgd.min.js"]`).forEach(s => s.remove());

      // ♻️ Inserta uno nuevo con cache-buster para forzar recarga
      const script = document.createElement('script');
      script.src = `${src}?cb=${Date.now()}`;
      script.defer = true;

      script.onload = () => {
        console.log('[flickity.pkgd.min.js] recargado correctamente');
        resolve();
      };
      script.onerror = (e) => {
        console.error('[flickity.pkgd.min.js] error al recargar:', e);
        reject(e);
      };

      document.head.appendChild(script);
    });
  }

  const defaults = {
    color: 'ash',
  };

  const selectors$R = {
    swatch: '[data-swatch]',
    swatchColor: '[data-swatch-color]',
    productBlock: '[data-product-block]',
    productImage: '[data-product-image]',
    productImageSecondary: '[data-product-image-secondary]',
    productImageHover: '[data-product-image-hover]',
    productId: '[data-product-id]',
    quickView: '[data-button-quick-view]',
    gridImage: '[data-grid-image]',
    link: '[data-grid-link]',
    loadHovers: '[data-load-hovers]',
  };

  const classes$D = {
    mediaVisible: 'product__media--featured-visible',
    mediaHoverVisible: 'product__media__hover-img--visible',
    noImage: 'swatch__link--no-image',
    noOutline: 'no-outline',
  };

  const attributes$x = {
    swatch: 'data-swatch',
    handle: 'data-swatch-handle',
    label: 'data-swatch-label',
    image: 'data-swatch-image',
    imageId: 'data-swatch-image-id',
    variant: 'data-swatch-variant',
    index: 'data-swatch-index',
    productId: 'data-product-id',
    swatchVariant: 'data-swatch-variant',
    variandId: 'data-variant-id',
    loaded: 'data-loaded',
    href: 'href',
    bgSet: 'data-bgset',
    aspectRatio: 'data-aspectratio',
    dataFetchedImage: 'data-fetched-image',
    dataFetchedImageIndex: 'data-fetched-image-index',
    dataGridImageDefault: 'data-grid-image-default',
    dataGridImageTarget: 'data-grid-image-target',
    dataGridImageTargetDefault: 'data-grid-image-target-default',
  };

  const loaders = {};

  function loadScript(options = {}) {
    if (!options.type) {
      options.type = 'json';
    }

    if (options.url) {
      if (loaders[options.url]) {
        return loaders[options.url];
      } else {
        return getScriptWithPromise(options.url, options.type);
      }
    } else if (options.json) {
      if (loaders[options.json]) {
        return Promise.resolve(loaders[options.json]);
      } else {
        return window
          .fetch(options.json)
          .then((response) => {
            return response.json();
          })
          .then((response) => {
            loaders[options.json] = response;
            return response;
          });
      }
    } else if (options.name) {
      const key = ''.concat(options.name, options.version);
      if (loaders[key]) {
        return loaders[key];
      } else {
        return loadShopifyWithPromise(options);
      }
    } else {
      return Promise.reject();
    }
  }

  class ColorMatch {
    constructor(options = {}) {
      this.settings = {
        ...defaults,
        ...options,
      };

      this.match = this.init();
    }

    getColor() {
      return this.match;
    }

    init() {
      const getColors = loadScript({json: theme.assets.swatches});
      return getColors
        .then((colors) => {
          return this.matchColors(colors, this.settings.color);
        })
        .catch((e) => {
          console.log('failed to load swatch colors script');
          console.log(e);
        });
    }

    matchColors(colors, name) {
      let bg = '#E5E5E5';
      let img = null;
      const path = theme.assets.base || '/';
      const comparisonName = name.toLowerCase().replace(/\s/g, '');
      const array = colors.colors;

      if (array) {
        let indexArray = null;

        const hexColorArr = array.filter((colorObj, index) => {
          const neatName = Object.keys(colorObj).toString().toLowerCase().replace(/\s/g, '');

          if (neatName === comparisonName) {
            indexArray = index;

            return colorObj;
          }
        });

        if (hexColorArr.length && indexArray !== null) {
          const value = Object.values(array[indexArray])[0];
          bg = value;

          if (value.includes('.jpg') || value.includes('.jpeg') || value.includes('.png') || value.includes('.svg')) {
            img = `${path}${value}`;
            bg = '#888888';
          }
        }
      }

      return {
        color: this.settings.color,
        path: img,
        hex: bg,
      };
    }
  }

  class Swatch {
    constructor(element) {
      this.element = element;
      this.swatchLink = this.element.nextElementSibling;
      this.colorString = element.getAttribute(attributes$x.swatch);
      this.image = this.element.getAttribute(attributes$x.image);
      this.imageId = this.element.getAttribute(attributes$x.imageId);
      this.variant = this.element.getAttribute(attributes$x.variant);
      this.outer = this.element.closest(selectors$R.productBlock);
      this.gridImage = null;
      this.imageDefault = null;
      this.hoverImages = [];
      this.loadHovers = null;

      const matcher = new ColorMatch({color: this.colorString});
      matcher.getColor().then((result) => {
        this.colorMatch = result;
        this.init();
      });
    }

    init() {
      this.setStyles();

      if (this.variant && this.outer) {
        this.handleHovers();
        this.handleClicks();
      }

      if (!this.image && this.swatchLink) {
        this.swatchLink.classList.add(classes$D.noImage);
      }
    }

    setStyles() {
      if (this.colorMatch && this.colorMatch.hex) {
        this.element.style.setProperty('--swatch', `${this.colorMatch.hex}`);
      }

      if (this.colorMatch && this.colorMatch.path) {
        this.element.style.setProperty('background-image', `url(${this.colorMatch.path})`);
      }
    }

    handleHovers() {
      // Load images on PGI swatch hover
      this.swatchLink.addEventListener('mouseenter', () => {
        this.imageReplace = null;

        if (this.imageId) {
          const target = this.outer.querySelector(`[${attributes$x.dataGridImageTarget}="${this.imageId}"]`);
          if (!target) {
            this.gridImage = this.outer.querySelector(selectors$R.gridImage);

            if (this.image && this.gridImage) {
              // Container width rounded to the nearest 180 pixels
              // Increses likelihood that the image will be cached
              const ratio = window.devicePixelRatio || 1;
              const pixels = this.gridImage.offsetWidth * ratio;
              const widthRounded = Math.ceil(pixels / 180) * 180;
              const defaultImageId = this.gridImage.hasAttribute(attributes$x.dataGridImageTargetDefault) ? this.gridImage.getAttribute(attributes$x.dataGridImageTargetDefault) : '';
              if (defaultImageId === this.imageId && this.gridImage.hasAttribute(attributes$x.dataGridImageDefault)) {
                // Get default loaded image
                this.imageReplace = this.gridImage.getAttribute(attributes$x.dataGridImageDefault);
                return;
              }

              if (this.element.hasAttribute(attributes$x.dataFetchedImage)) {
                // Get already loaded image
                this.imageReplace = this.element.getAttribute(attributes$x.dataFetchedImage);
              } else {
                // Fetch new image
                const sizedImage = getSizedImageUrl(this.image, `${widthRounded}x`);

                window
                  .fetch(sizedImage)
                  .then((response) => {
                    return response.blob();
                  })
                  .then((blob) => {
                    const objectURL = URL.createObjectURL(blob);
                    this.imageReplace = `url("${objectURL}")`;
                    this.element.setAttribute(attributes$x.dataFetchedImage, this.imageReplace);

                    if (
                      this.element.hasAttribute(attributes$x.index) &&
                      this.outer.hasAttribute(attributes$x.dataFetchedImageIndex) &&
                      parseInt(this.element.getAttribute(attributes$x.index)) === parseInt(this.outer.getAttribute(attributes$x.dataFetchedImageIndex))
                    ) {
                      this.replaceImages();

                      this.outer.removeAttribute(attributes$x.dataFetchedImageIndex);
                    }
                  })
                  .catch((error) => {
                    console.log(`Error: ${error}`);
                  });
              }
            }
          }
        }

        this.loadHovers = this.outer.querySelector(selectors$R.loadHovers);

        if (this.loadHovers && !this.loadHovers?.hasAttribute(attributes$x.loaded)) {
          const content = document.createElement('div');
          content.appendChild(this.loadHovers.querySelector('template').content.firstElementChild.cloneNode(true));
          this.loadHovers.appendChild(content);
          this.loadHovers.setAttribute(attributes$x.loaded, true);
        }
      });
    }

    handleClicks() {
      // Change PGI featured image on swatch click
      this.swatchLink.addEventListener('click', (event) => {
        const isFocusEnabled = !document.body.classList.contains(classes$D.noOutline);

        if (!isFocusEnabled) {
          event.preventDefault();
          this.updateImagesAndLinksOnEvent();
        }
      });

      this.swatchLink.addEventListener('keyup', (event) => {
        const isFocusEnabled = !document.body.classList.contains(classes$D.noOutline);

        if (event.code !== theme.keyboardKeys.ENTER && event.code !== theme.keyboardKeys.NUMPADENTER) {
          return;
        }

        if (!isFocusEnabled) {
          event.preventDefault();
          this.swatchLink.dispatchEvent(new Event('mouseenter', {bubbles: true}));
          this.updateImagesAndLinksOnEvent();
        }
      });
    }

    updateImagesAndLinksOnEvent() {
      this.updateLinks();
      this.replaceImages();
    }

    updateLinks() {
      this.linkElements = this.outer.querySelectorAll(selectors$R.link);
      this.quickView = this.outer.querySelector(selectors$R.quickView);

      // Update links
      if (this.linkElements.length) {
        this.linkElements.forEach((element) => {
          const destination = getUrlWithVariant(element.getAttribute('href'), this.variant);
          element.setAttribute('href', destination);
        });
      }

      // Change quickview variant with swatch one
      if (this.quickView && theme.settings.quickBuy === 'quick_buy') {
        this.quickView.setAttribute(attributes$x.variandId, this.variant);
      }
    }

    replaceImages() {
      this.imageSecondary = this.outer.querySelector(selectors$R.productImageSecondary);
      this.outer.removeAttribute(attributes$x.dataFetchedImageIndex);

      if (!this.imageReplace && this.element.hasAttribute(attributes$x.index)) {
        this.outer.setAttribute(attributes$x.dataFetchedImageIndex, parseInt(this.element.getAttribute(attributes$x.index)));
      }

      // Add new loaded image and sync with the secondary image for smooth animation
      if (this.imageReplace && this.gridImage && this.imageId) {
        this.gridImage.setAttribute(attributes$x.dataGridImageTarget, this.imageId);

        if (!this.gridImage.hasAttribute(attributes$x.dataGridImageDefault)) {
          this.gridImage.setAttribute(attributes$x.dataGridImageDefault, window.getComputedStyle(this.gridImage).backgroundImage);
        }

        const onAnimationEnd = () => {
          requestAnimationFrame(() => {
            this.gridImage.style.setProperty('background-image', this.imageReplace);

            requestAnimationFrame(() => {
              this.imageSecondary.classList.remove(classes$D.mediaVisible);
            });
          });

          this.imageSecondary.removeEventListener('animationend', onAnimationEnd);
        };

        requestAnimationFrame(() => {
          this.imageSecondary.classList.add(classes$D.mediaVisible);
          this.imageSecondary.style.setProperty('background-image', this.imageReplace);
        });

        this.imageSecondary.addEventListener('animationend', onAnimationEnd);
      }

      // Change all hover images classes
      if (theme.settings.productGridHover === 'image') {
        this.hoverImages = this.outer.querySelectorAll(selectors$R.productImageHover);
      }

      if (this.hoverImages.length > 1) {
        this.hoverImages.forEach((hoverImage) => {
          hoverImage.classList.remove(classes$D.mediaHoverVisible);

          if (hoverImage.getAttribute(attributes$x.variandId) === this.variant) {
            hoverImage.classList.add(classes$D.mediaHoverVisible);
          } else {
            this.hoverImages[0].classList.add(classes$D.mediaHoverVisible);
          }
        });
      }
    }
  }

  window.initStickySwatches = function(root){
    if (!root) return;
    // Evitar dobles inits en re-render
    root.querySelectorAll('[data-swatch]:not([data-loaded])').forEach(function(el){
      try {
        // 'Swatch' ya está definido por theme.dev.js en PDP/colecciones
        new Swatch(el);
        el.setAttribute('data-loaded','');
      } catch(e) {
        console.warn('No se pudo instanciar Swatch para', el, e);
      }
    });
  };
  
  // Fetch and display product content when quick view triggers are clicked
  async function handleQuickViewClick(event, variantId = false) {
    const trigger = event.target.closest(".quick-view-trigger") ? event.target.closest(".quick-view-trigger") : event.target.closest(".sticky-quick-view__dropdown-item");
    if (!trigger) return;
    event.preventDefault();

    const handle = trigger.dataset.handle;
    if (!handle) return;

    try {
      const res = await fetch(`/products/${handle}${variantId ? `?variant=${variantId}` : ''}`);
      const htmlString = await res.text();

      const doc = new DOMParser().parseFromString(htmlString, 'text/html');
      const main = doc.getElementById('MainContent');
      if (!main) throw new Error('No se encontró #MainContent en la respuesta');

      const contentContainer = document.getElementById('product-modal-content');
      contentContainer.innerHTML = '';

      const mainSection = main.querySelector('.product-single');
      const stickyQuickViewSection = doc.querySelector('.sticky-quick-view-section');

      if (mainSection) contentContainer.appendChild(mainSection.cloneNode(true));
      if (stickyQuickViewSection) contentContainer.appendChild(stickyQuickViewSection.cloneNode(true));

      await reloadVendorScript();

      await initProductSlider(contentContainer);
      await initTabs(contentContainer);
      window.initStickySwatches(contentContainer);

      if (variantId === false) openModal();
    } catch (err) {
      console.error('Error loading product modal:', err);
    }
  }

  function openModal() {
    const modal = document.getElementById("product-modal");
    modal.classList.remove("hidden");
    modal.setAttribute("aria-hidden", "false");
  }

  function closeModal() {
    const modal = document.getElementById("product-modal");
    modal.classList.add("hidden");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    // clean up content for next open (optional)
    document.getElementById("product-modal-content").innerHTML = "";
  }

  // Close modal on overlay or close button click
  document.addEventListener("click", function (event) {
    if (event.target.matches(".quick-view-trigger")) {
      handleQuickViewClick(event);
    } else if (
      event.target.closest(".product-modal__close") ||
      event.target.matches(".product-modal__overlay")
    ) {
      closeModal();
    }
  });

  // Optional: close modal on Escape key
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      const modal = document.getElementById("product-modal");
      if (!modal.classList.contains("hidden")) closeModal();
    }
  });

  let variantData = [];
  let selectedOptions = {};

  // Helper to find the sticky quick view element associated with a clicked element
  function findStickyBar(el) {
    return el.closest('.sticky-quick-view');
  }

  // Update variant and UI for a given sticky bar
  function updateVariant(stickyBar, state = false) {
    if (!stickyBar) return;
    let addButton = stickyBar.querySelector('.sticky-quick-view__add-to-cart');
    let priceContainer = addButton && addButton.querySelector('.sticky-quick-view__price');
    if (!addButton || !priceContainer) return;
    variantData = stickyBar.dataset.variantData ? JSON.parse(stickyBar.dataset.variantData) : [];

    // Initialise with the first variant’s options if available
    if (state && variantData.length > 0) {
      variantData[0].options.forEach(function (opt, idx) {
        selectedOptions[idx] = opt;
      });
    } else if (!state && variantData.length > 0) {
      let lstLabels = stickyBar.querySelectorAll('.sticky-quick-view__label');
      lstLabels.forEach((label, idx) => {
        selectedOptions[idx] = label.textContent.trim();
      });
    }
    
    let match = variantData.find(function (variant) {
      return variant.options.every(function (option, idx) {
        return selectedOptions[idx] === option;
      });
    });

    if (match) {
      addButton.dataset.variantId = match.id;
      priceContainer.textContent = '– ' + match.price;
      addButton.disabled = !match.available;
    } else {
      addButton.dataset.variantId = '';
      priceContainer.textContent = '';
      addButton.disabled = true;
    }
  }

  // Delegated click handling for dropdown toggles and items
  document.addEventListener('click', function (event) {
    if (event.target.closest('label[data-swatch]')) {
      const label = event.target.closest('label[data-swatch]');
      if (!label) return;

      const swatchValue = label.dataset.swatch;

      const dropdownItems = document.querySelectorAll('.sticky-quick-view__dropdown-item');

      const match = Array.from(dropdownItems).find(
        item => item.dataset.value === swatchValue
      );

      if (match) match.click();
    }
    if (event.target && event.target.closest('.sticky-quick-view__dropdown-toggle')) {
      let dropdown = event.target.closest('.sticky-quick-view__dropdown');
      let stickyBar = findStickyBar(event.target);
      if (!dropdown || !stickyBar) return;
      let isOpen = dropdown.classList.contains('is-open');
      // Close any other open dropdowns within this sticky bar
      stickyBar.querySelectorAll('.sticky-quick-view__dropdown.is-open').forEach(function (otherDropdown) {
        if (otherDropdown !== dropdown) {
          otherDropdown.classList.remove('is-open');
          let otherToggle = otherDropdown.querySelector('.sticky-quick-view__dropdown-toggle');
          if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
        }
      });
      // Toggle the clicked dropdown
      dropdown.classList.toggle('is-open', !isOpen);
      event.target.closest('.sticky-quick-view__dropdown-toggle').setAttribute('aria-expanded', String(!isOpen));
      event.stopPropagation();
      return;
    } else if (event.target && event.target.closest('.sticky-quick-view__dropdown-item')) {
      let item = event.target.closest('.sticky-quick-view__dropdown-item');
      let value = item.getAttribute('data-value');
      let index = parseInt(item.getAttribute('data-index'), 10);
      let dropdown = item.closest('.sticky-quick-view__dropdown');
      let stickyBar = findStickyBar(item);
      if (!dropdown || !stickyBar) return;
      // Update selected option state
      selectedOptions[index] = value;
      // Update the toggle’s label and swatch
      let toggleBtn = dropdown.querySelector('.sticky-quick-view__dropdown-toggle');
      if (toggleBtn) {
        let labelSpan = toggleBtn.querySelector('.sticky-quick-view__label');
        if (labelSpan) labelSpan.textContent = value;
        let swatchSpan = toggleBtn.querySelector('.sticky-quick-view__color-swatch');
        if (swatchSpan && item.getAttribute('style')) {
          swatchSpan.setAttribute('style', item.getAttribute('style'));
        }
        toggleBtn.setAttribute('aria-expanded', 'false');
      }
      // Close the dropdown
      dropdown.classList.remove('is-open');
      // Update variant and price
      updateVariant(stickyBar);
      const addButton = stickyBar.querySelector('.sticky-quick-view__add-to-cart');
      if (addButton) handleQuickViewClick(event, addButton.dataset.variantId);
    } else if (event.target && event.target.closest('.sticky-quick-view__add-to-cart')) {
      let addBtn = event.target.closest('.sticky-quick-view__add-to-cart');
      if (addBtn) {
        let variantId = addBtn.dataset.variantId;
        if (!variantId) return;
        addBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
          .then(function (response) { return response.json(); })
          .then(function (data) {
            document.dispatchEvent(new CustomEvent('shopify:custom:add-to-cart', { userId: 123, action: "clicked" }));
            closeModal();
            addBtn.disabled = false;
          })
          .catch(function () {
            addBtn.disabled = false;
          });
        event.stopPropagation();
      }
    }
    // Click outside: close all open dropdowns
    document.querySelectorAll('.sticky-quick-view__dropdown.is-open').forEach(function (openDropdown) {
      openDropdown.classList.remove('is-open');
      let t = openDropdown.querySelector('.sticky-quick-view__dropdown-toggle');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });

  // Initialise variant display for any existing sticky bars on load
  document.querySelectorAll('.sticky-quick-view').forEach(function (bar) {
    updateVariant(bar, true);
  });
});

(function observeCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  const modal  = document.getElementById('product-modal');
  const OPEN_CLASS = 'is-open';

  if (!drawer) {
    setTimeout(observeCartDrawer, 200);
    return;
  }

  function closeQuickView() {
    if (modal && !modal.classList.contains('hidden')) {
      modal.classList.add('hidden');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = "";
    }
  }

  if (drawer.classList.contains(OPEN_CLASS)) {
    closeQuickView();
  }

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.attributeName === 'class') {
        const isOpen = drawer.classList.contains(OPEN_CLASS);
        if (isOpen) {
          closeQuickView();
        }
      }
    }
  });

  observer.observe(drawer, { attributes: true });

})();
